import { useEffect, useRef } from 'react';
import { useAppSelector, useSetBaseMutation } from '@spartalabs/pdc-core';
import { resolveFleetBaseDivisions } from 'utils/resolveFleetBaseDivisions';

export const useSyncFleetBaseOnLogin = () => {
  const justLoggedIn = useAppSelector(state => state.authSlicer.justLoggedIn);
  const { token, currentGroupId, currentDivisionId, groups } = useAppSelector(
    state => state.authSlicer.user,
  );
  const [setBase] = useSetBaseMutation();
  const syncedForSessionRef = useRef(false);

  useEffect(() => {
    if (!justLoggedIn) {
      syncedForSessionRef.current = false;
      return;
    }

    if (!token || !currentGroupId || syncedForSessionRef.current) return;

    const divisions = resolveFleetBaseDivisions(
      groups,
      currentGroupId,
      undefined,
      currentDivisionId,
    );

    if (divisions.length === 0) return;

    syncedForSessionRef.current = true;

    setBase({ group: currentGroupId, divisions }).catch(() => {
      syncedForSessionRef.current = false;
    });
  }, [
    justLoggedIn,
    token,
    currentGroupId,
    currentDivisionId,
    groups,
    setBase,
  ]);
};
